<template>
    <label class="text-sm block text-cavilam-primary font-semibold" :for="name">
        {{ __(libelle) }} <sup v-show="required" class="text-red-500">*</sup>
    </label>
    <select :id="name" v-model="$parent.form[name]"
            :class="{'pointer-events-none opacity-75':readonly}"
            class="w-full px-2 py-2 text-gray-700 rounded border-cavilam-primary"
            :required="required">
        <option :value="null"> -- {{ __('veuillez_selectionner_une_langue') }} -- </option>
        <option v-for="langue in liste" :value="langue">{{ langue }}</option>
    </select>
    <p class="text-red-500 text-xs" :class="{'invisible':!$parent.form.errors[name]}">{{ __($parent.form.errors[name]) }}</p>
</template>

<script>
export default {
    name: "PaysSelector",
    props: {
        name: String,
        libelle: String,
        required: Boolean,
        readonly: Boolean
    },
    data() {
        return {
            liste: [
                'French',
                'English',
                'German',
                'Spanish',
                'Italian',
                'Abkhazian',
                'Afar',
                'Afrikaans',
                'Albanian',
                'German',
                'German',
                'Amharic',
                'English',
                'English',
                'Arab',
                'Armenian',
                'Assamese',
                'Austrian',
                'Aymara',
                'Azeri',
                'Bashkir',
                'Basque',
                'Bengali',
                'Bislama',
                'Belarusian',
                'Bihari',
                'Burmese',
                'Breton',
                'Bulgarian',
                'Kashmiri',
                'Catalan',
                'Chinese',
                'Singhalese',
                'Korean',
                'Corsica',
                'Croatian',
                'Danish',
                'Scottish',
                'Spanish',
                'Esperanto',
                'Estonian',
                'Faroese',
                'Fijian',
                'Finnish',
                'French',
                'WestFrisian',
                'Gallego',
                'Welsh',
                'Georgian',
                'Greek',
                'Greenlandic',
                'Guarani',
                'Gujarati',
                'Hausa',
                'Hebrew',
                'Hindi',
                'Hungarian',
                'icelandic',
                'Inupiaq',
                'Irish',
                'Icelandic',
                'Italian',
                'Italian',
                'Japanese',
                'Javanese',
                'Kannada',
                'Kazakh',
                'Khmer',
                'kinyarwanda',
                'Kirghiz',
                'Kirundi',
                'Kurdish',
                'Lao',
                'Latin',
                'Latvian',
                'Lingala',
                'Lithuanian',
                'Macedonian',
                'Malay',
                'Malayalam',
                'Malagasy',
                'Maltese',
                'Maori',
                'Marathi',
                'Moldavian',
                'Mongolian',
                'Nauruan',
                'Dutch',
                'Nepalese',
                'Norwegian',
                'Occitan',
                'Oriya',
                'Urdu',
                'Uzbek',
                'Pashto',
                'Palestinian',
                'Punjabi',
                'Persian',
                'Polish',
                'Portuguese',
                'quechua',
                'Romansh',
                'Romanian',
                'Russian',
                'Samoan',
                'Sanskrit',
                'Serbian',
                'Serbo-Croatian',
                'Shona',
                'Sindhi',
                'Slovak',
                'Slovenian',
                'Somali',
                'SouthernSotho',
                'Sundanese',
                'Swedish',
                'Swahili',
                'Swati',
                'Tajik',
                'tagalog',
                'Tamil',
                'Tatar',
                'Czech',
                'Telugu',
                'Thai',
                'Tibetan',
                'Tigrigna',
                'Tongan',
                'Tsonga',
                'Tswana',
                'Turkish',
                'Turkmen',
                'Twi',
                'Ukrainian',
                'Vietnamese',
                'Volapük',
                'Wolof',
                'Xhosa',
                'Yiddish',
                'Yoruba',
                'Zulu',
            ],
        };
    },
}
</script>

<style scoped>

</style>
